import React from 'react';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import {
  Badge,
  BadgePriority as BADGE_PRIORITY,
  HeroImage,
  ImageResizeOptions,
} from 'wix-ui-tpa/cssVars';
import { VideoFillXSmall as Camera } from '@wix/wix-ui-icons-common/on-stage/system';
import { DataHooks } from '../../constants';
import { classes, st } from './ServiceDetailsHero.st.css';

export type ServiceDetailsHeroProps = {
  serviceImage?: { src: string; alt?: string };
  serviceName?: string;
  availableOnline?: boolean;
};

const ServiceDetailsHero: React.FC<ServiceDetailsHeroProps> = ({
  serviceImage,
  serviceName,
  availableOnline,
}) => {
  const { isMobile } = useEnvironment();
  const { t } = useTranslation();

  return (
    <div className={st(classes.root, { isMobile })}>
      {serviceImage && (
        <div className={classes.media} data-hook={DataHooks.Image}>
          <HeroImage
            className={classes.image}
            src={serviceImage.src}
            alt={serviceImage.alt ?? serviceName ?? ''}
            resize={ImageResizeOptions.cover}
            fluid
          />
        </div>
      )}
      {availableOnline && (
        <Badge
          className={classes.badge}
          data-hook={DataHooks.OnlineBadge}
          icon={<Camera />}
          priority={BADGE_PRIORITY.light}
        >
          {t('service-details.online-badge')}
        </Badge>
      )}
    </div>
  );
};

export default ServiceDetailsHero;
